import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IDocumentFolderEditItem extends IEditItem {
    code: string;
    path: string;
    comment: string;
    image: string;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    inheritedFileFilterIds: string[];
    fileFilterIds: string[];
}

export class DocumentFolderEditItem extends EditItem implements IDocumentFolderEditItem {
    code: string;
    path: string;
    comment: string;
    image: string;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    inheritedFileFilterIds: string[];
    fileFilterIds: string[];

    constructor();
    constructor(obj: IDocumentFolderEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.path = obj && obj.path || "";
        this.comment = obj && obj.comment || "";
        this.image = obj && obj.image || "";
        this.createUser = null;
        if (obj.createUser) {
            this.createUser = new ModifyUser(obj ? obj.createUser : null);
        }
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.inheritedFileFilterIds = obj && obj.inheritedFileFilterIds || [];
        this.fileFilterIds = obj && obj.fileFilterIds || [];
    }
}